import { useState } from "react";

function useFilterState<T>(initialFilters: Array<FilterFunction<T>> = []) {
	const [filters, setFilters] = useState(initialFilters);

	return { filters, setFilters };
}

export default useFilterState;
